import { Component, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { appSettingsModule } from '@/store/app-settings-module';
import { TestCaseResponse } from '@/models/test-case/test-case-response';
import { testCaseService } from '@/services/testcase-service';

@Component
export default class TestCases extends Vue {

    testCases: TestCaseResponse[] = []
    fields = [ { key: 'name' }, { key: 'created' }, { key: 'campaigns' }, { key: 'action', label: '' }]
    currentPage: number = 1
    totalCount: number = 0
    pageSize: number = 7
    loading = false
    refreshTimer: number = null

    get mailWizzInstanceId() { return appSettingsModule.activeMailWizzId }

    @Watch('mailWizzInstanceId')
    async mailWizzInstanceIdChanged(){
        await this.refresh()
    }

    async mounted() {
        await this.refresh()
        this.refreshTimer = setInterval(this.loadTestCases, 10000)
    }

    beforeDestroy () {
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer)
        }
    }
    
    async refresh() {
        this.currentPage = 1;
        this.loading = true
        try {
            await this.loadTestCases(this.currentPage)
        }
        finally {
            this.loading = false
        }
    }

    async loadTestCases(page: number) {
        [this.totalCount, this.testCases] = await Promise.all([
            testCaseService.getTotalCount(),
            testCaseService.getTestCasesPage(page, this.pageSize)
        ])
    }

    generateNewTestCase() {
        this.$router.push('/testcases/new')
    }

    viewTestCase(testCase: TestCaseResponse) {
        this.$router.push(`/testcases/${testCase.id}`)
    }

    async deleteTestCase(testCase: TestCaseResponse) {
        if (await this.$confirmWarning(`Are you sure you what to delete Test Case '${testCase.name}'?`)) {
            await testCaseService.delete({ resourceId: testCase.id })
            await this.refresh()
        }
    }

    copyTestCase(testCase: TestCaseResponse) {
        this.$router.push({
            path: '/testcases/new/',
            query: { copyFromId: testCase.id.toString() }
        })
    }
}
